import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import PlanPicker from "../components/PlanPicker";

/* Pagina di blocco a schermo intero: prova terminata / pagamento mancato / disdetta. */
export default function Piano() {
  const { user, logout } = useAuth();
  const b = user?.billing || {};
  const team = !!user?.team_role;
  const title = b.reason === "past_due" ? "Pagamento non riuscito" : b.reason === "canceled" ? "Abbonamento non attivo" : "La prova è terminata";
  const sub = b.reason === "past_due" ? "L'ultimo addebito non è andato a buon fine. Aggiorna la carta per riattivare subito l'accesso." : "I tuoi dati sono al sicuro. Scegli il piano per riprendere da dove avevi lasciato.";
  return (
    <div className="min-h-screen bg-background px-4 py-10" data-testid="blocked-page">
      <div className="mx-auto max-w-4xl">
        <div className="mb-8 text-center">
          <img src="/logo.svg" alt="Athanor Lab" className="mx-auto mb-6 h-10" onError={(e) => { e.currentTarget.style.display = "none"; }} />
          <h1 className="text-3xl font-semibold tracking-tight text-slate-50 sm:text-4xl" data-testid="blocked-title">{title}</h1>
          <p className="mx-auto mt-2 max-w-xl text-base text-slate-400">{team ? "Chiedi al titolare di attivare il piano: appena fatto potrai rientrare." : sub}</p>
        </div>
        {!team && <PlanPicker current={null} />}
        {!team && b.reason === "past_due" && <PortalButton />}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4 text-xs text-slate-500">
          <Link to="/assistenza" className="hover:text-slate-200" data-testid="blocked-help">Hai bisogno di aiuto? Prenota una chiamata</Link>
          <button onClick={logout} className="hover:text-slate-200" data-testid="blocked-logout">Esci</button>
        </div>
      </div>
    </div>
  );
}

function PortalButton() {
  const open = async () => { const { api } = await import("../lib/api"); const { data } = await api.post("/payments/portal", { origin_url: window.location.origin }); window.location.href = data.url; };
  return <div className="mt-5 text-center"><button onClick={open} className="btn btn-primary" data-testid="blocked-portal">Aggiorna la carta</button></div>;
}
